export default function generateReportsListDirective() {
  console.log('app.components.global.generateReportsList created');
  return {
    template: require('./generate-reports-list.directive.html'),
    controller: 'GenerateReportsListController',
    controllerAs: 'generateReportsListVM',
    bindToController: true,
    replace: true,
    scope: {
      serviceId: '=',
      groupId: '=',
      customerId: '=',
      atCustId: '=',
      usesFilter: '=',
      usesFocus: '=',
    },
  };
}
